import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment'; // NOSONAR: This import is necessary for moment usage. Default import doesn't work.
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppConfiguration } from '../../core/models/app-configuration.model';
import { TwoFaClient, TwoFaClientPassword, WebMailInfo } from '../model/twofa-client.model';

/**
 * 2fa Client Service
 * @description Angular service used for retrieve and update 2fa client password
 */
@Injectable({ providedIn: 'root' })
export class TwoFaClientService {
  constructor(private readonly http: HttpClient, private readonly appConfig: AppConfiguration) { }

  getResourceUrl(): string {
    return this.appConfig.serverApiUrl + '/api/v1/apikeys';
  }

  getCurrent2faClientStatus(): Observable<TwoFaClient> {
    return this.http
      .get<TwoFaClient>(`${this.getResourceUrl()}/any`)
      .pipe(map((client: TwoFaClient) => this.convertTwoFaClientFromServer(client)));
  }

  createClientPassword(): Observable<TwoFaClientPassword> {
    return this.http
      .post<TwoFaClientPassword>(`${this.getResourceUrl()}`, {})
      .pipe(map((client: TwoFaClientPassword) => this.convertTwoFaClientPwdFromServer(client)));
  }
  renewClientPassword(authReqId: string): Observable<TwoFaClientPassword> {
    const options = { headers: new HttpHeaders({ authPermission: authReqId }) };
    return this.http
      .post<TwoFaClientPassword>(`${this.getResourceUrl()}/renew`, {}, options)
      .pipe(map((client: TwoFaClientPassword) => this.convertTwoFaClientPwdFromServer(client)));
  }
  renewClientPassword2fa(authReqId: string): Observable<TwoFaClientPassword> {
    const options = { headers: new HttpHeaders({ authPermission: authReqId }) };
    return this.http
      .post<TwoFaClientPassword>(`${this.getResourceUrl()}/renew2fa`, {}, options)
      .pipe(map((client: TwoFaClientPassword) => this.convertTwoFaClientPwdFromServer(client)));
  }

  deleteClientPassword(): Observable<void> {
    return this.http.delete<void>(`${this.getResourceUrl()}/all`);
  }

  getActivateProtocolLink(companyName: string): Observable<WebMailInfo> {
    return this.http.get<WebMailInfo>(`/api/v1/web_mail/info`, { params: { uri: companyName } });
  }

  /**
   * Utility function for convert server date to client date for every field of TwoFaClient
   * @param res Authorization status object contain date variables
   */
  protected convertTwoFaClientFromServer(res: TwoFaClient): TwoFaClient {
    if (res) {
      res.createTsLastApiKey = res.createTsLastApiKey ? moment(res.createTsLastApiKey) : undefined;
      res.expireTsLastApiKey = res.expireTsLastApiKey ? moment(res.expireTsLastApiKey) : undefined;
    }
    return res;
  }

  /**
   * Utility function for convert server date to client date for every field of TwoFaClient
   * @param res Authorization status object contain date variables
   */
  protected convertTwoFaClientPwdFromServer(res: TwoFaClientPassword): TwoFaClientPassword {
    if (res) {
      res.createTs = res.createTs ? moment(res.createTs) : undefined;
      res.expireTs = res.expireTs ? moment(res.expireTs) : undefined;
    }
    return res;
  }
}
